import type { CanvasTypeId } from './use-canvases'

export const CANVAS_TYPE_OPTIONS: {
  id: CanvasTypeId
  label: string
  description: string
  stub: boolean
}[] = [
  {
    id: 'business_model',
    label: 'Business Model Canvas',
    description: 'Nine building blocks for how a business creates and captures value.',
    stub: false,
  },
  {
    id: 'lean',
    label: 'Lean Canvas',
    description: 'Problem-first canvas for early ventures. Stub template for now.',
    stub: true,
  },
  {
    id: 'strategy',
    label: 'Strategy Canvas',
    description: 'Playing-to-win choices. Stub template for now.',
    stub: true,
  },
]
